import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardButtonComponent } from './card-button.component';

@NgModule({
  declarations: [CardButtonComponent],
  exports: [CardButtonComponent],
  imports: [CommonModule],
})
export class CardButtonModule {}
